import {
    ShowMoreButton,
    SwiperSlideStackFinal,
} from "./PostsPromoSlider.styles";
import React from "react";
import { Typography } from "@mui/material";
import { usePostListModalStore } from "../../Components/Modals/PostListModal/PostListModalStore";
import { UserType } from "@shared/types";
import { StackedAvatars } from "./StackedAvatars";

export function PostsPromoFinalSlide({ users }: { users: UserType[] }) {
    const { setIsPostListModalOpen } = usePostListModalStore();

    return (
        <SwiperSlideStackFinal>
            <StackedAvatars users={users} />
            <Typography textAlign="center">
                Entdecke weitere spannende Beiträge in der Community!
            </Typography>
            <ShowMoreButton onClick={() => setIsPostListModalOpen(true)}>
                mehr anzeigen
            </ShowMoreButton>
        </SwiperSlideStackFinal>
    );
}
